import { Box } from '@mui/material';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './pages/login/LoginPage';
import MainLayout from './layout/MainLayout';
import { menuItems, MenuItem, SubMenuItem } from './config/menuItems';
import { Provider, useSelector } from 'react-redux';
import store, { RootState } from './store/store';
import Header from './layout/Header';
import VerifyCodePage from './pages/login/VerifyCodePage';
import ForgotPasswordPage from './pages/login/ForgotPasswordPage';
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import AuthGuard from './hooks/auth-guard';
import ChangePassword from './pages/login/ChangePassword';
import ThemeProvider from './theme';
import TransactionsPage from './pages/transactions/TransactionsPage';
import { SnackbarProvider } from 'notistack';
import NotFoundPage from './pages/NotFoundPage';
import './index.css';

function generateRoutes(items: (MenuItem | SubMenuItem)[]) {
  return items.map((item: MenuItem | SubMenuItem) => {
    if ('children' in item && item.children) {
      return item.children.map((subItem: SubMenuItem) => (
        subItem.component ?
          <Route
            key={subItem.route}
            path={subItem.route}
            element={<AuthGuard> <subItem.component /></AuthGuard>}
          />
          : null
      ));
    }
    return item.component ?
      <Route
        key={item.route}
        path={item.route}
        element={<AuthGuard><item.component /></AuthGuard>}
      />
      : null;
  }).flat();
}

const InnerApp = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const authRoutes = [
    '/login',
    '/authentication/login',
    '/authentication/verify',
    '/authentication/forget-pass',
    '/reset-password',
  ];

  const isAuthRoute = authRoutes.includes(location.pathname);

  return (
    isAuthRoute ? (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/authentication/login" element={<LoginPage />} />
        <Route path="/authentication/verify" element={<VerifyCodePage />} />
        <Route path="/authentication/forget-pass" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/authentication/change-pass" element={<ChangePassword />} />
      </Routes>
    ) : (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%', overflow: 'hidden' }}>
        <Header onDrawerToggle={handleDrawerToggle} drawerOpen={drawerOpen} />
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <MainLayout drawerOpen={drawerOpen} onDrawerToggle={handleDrawerToggle}>
          <Routes>
            {/* <Route index element={<AuthGuard><Navigate to="/dashboard/transactions" /></AuthGuard>} /> */}
            <Route path="/" element={<AuthGuard><TransactionsPage /></AuthGuard>} />
            <Route path="/dashboard/transaction" element={<AuthGuard><Navigate to="/" replace /></AuthGuard>} />
            <Route path="/dashboard/transactions" element={<AuthGuard><TransactionsPage /></AuthGuard>} />
            <Route path="/authentication/change-pass" element={<ChangePassword />} />
            {/* Tüm rotaları menuItems'dan oluştur (filtrelenmemiş) */}
            {generateRoutes(menuItems)}
           <Route path="/*" element={<NotFoundPage />} />
          </Routes>
        </MainLayout>
        </Box>
      </Box>
    )
  );
};

const App = () => (
  <Provider store={store}>
    <ThemeProvider>
      <SnackbarProvider maxSnack={3}>
        <Router basename="/Kurumsal">
          <InnerApp />
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>
);

export default App;